






































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import Url from "@/lib/url";
import SignalRAspNetCoreHelper from "@/lib/SignalRAspNetCoreHelper";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateEnterprisenformation from "./create-enterpriseinformation.vue";
import EditEnterprisenformation from './edit-enterpriseinformation.vue';
let ispartysrc= require("@/images/danghui.png");


 
import AppConsts from "@/lib/appconst";

class PageBHUserRequest extends PageRequest {
  Keyword: string;
  corporatetype: number; //nullable
  status: number;
   
}

 @Component({
        components:{ }
    })
export default class Enterprisenformation extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageBHUserRequest = new PageBHUserRequest();
   
  
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  connection:any=null;
  tosuer:string="";
  get list() {
               
    return [];
  }
  get loading() {
    return this.$store.state.enterpriseinformation.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("enterpriseinformation/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("enterpriseinformation/setPageSize", pagesize);
    this.getpage();
  }
  
  async getpage() {
   
  }
     
  get pageSize() {
    return this.$store.state.enterpriseinformation.pageSize;
  }
  get totalCount() {
    return this.$store.state.enterpriseinformation.totalCount;
  }
  get currentPage() {
    return this.$store.state.enterpriseinformation.currentPage;
  }
  get corporatetypelist(){

    return this.$store.state.enterpriseinformation.corporatetypelist;
  }
   
 
  columns = [
     {
      
      title: this.L("ID"),
      key: "id",
      width: 100,
    },
     {
      
      title: this.L("城市名称"),
      key: "corporatename",
      
    },
      

     {
      
      title: this.L("联系人"),
      key: "contacts",
      width: 100, 
    },
     {
      
      title: this.L("联系电话"),
      key: "phone",
      width: 150, 
    },
   
    {
    
      title: this.L("是否启用"),
       width: 100,
      render: (h: any, params: any) => {
        return h("span", params.row.status==true ? this.L("Yes"): this.L("No") );
      },
    },
    
     
     
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("enterpriseinformation/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteDataConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "enterpriseinformation/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    
     
   
    
    
  }

  corporatetypeTxt(corporatetype){
          var txt="";
          var lst=this.corporatetypelist; 
          lst.forEach(item=>{
          
            if(item.id==corporatetype){
              txt=item.name;
            }             
         })
      return txt;
  }

  async  getCitys() {
   
     
     await this.$store.dispatch({
      type: "enterpriseinformation/getCitys",
    });
  }

  async getIndustrycategoryAll(){

      await this.$store.dispatch({
      type: "enterpriseinformation/getIndustrycategoryAll",
    });
  }

 //导出
   async  exportExcel() {
     
        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}
 
    

  
}




